import $axios from "../api/accessor";
import { $api } from "../api/api";

export const LiveSupportService = {
  async getAllUserList() {
    let response = await $axios.get($api("user_lists")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getChatById(id: number) {
    let response = await $axios.get($api("chat", { id })).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async sendMessage(id: number, payload: { is_file: number; content: string }) {
    let response = await $axios
      .post($api("send_chat", { id }), payload)
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
